import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "support-video-title" }
const _hoisted_2 = ["aria-busy"]
const _hoisted_3 = ["src", "aria-label"]
const _hoisted_4 = ["src", "title"]
const _hoisted_5 = {
  key: 0,
  class: "support-video-error",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onHide: _ctx.reset
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "support-video-dialog" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "support-video-header" }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1),
              _createVNode(_component_q_btn, {
                flat: "",
                round: "",
                dense: "",
                icon: "close",
                "aria-label": "Close video",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Close video", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "support-video-frame",
                "aria-busy": _ctx.loading
              }, [
                (_ctx.videoUrl && _ctx.getPlayback)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      ref: "player",
                      src: _ctx.videoUrl,
                      "aria-label": _ctx.title,
                      controls: "",
                      controlslist: "nodownload",
                      playsinline: "",
                      preload: "metadata",
                      onTimeupdate: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.trackPosition && _ctx.trackPosition(...args))),
                      onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMediaError && _ctx.onMediaError(...args)))
                    }, null, 40, _hoisted_3))
                  : (_ctx.embedUrl && _ctx.modelValue)
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 1,
                        src: _ctx.embedUrl,
                        title: _ctx.title,
                        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share",
                        referrerpolicy: "strict-origin-when-cross-origin",
                        allowfullscreen: ""
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 2,
                      class: "support-video-spinner",
                      color: "primary",
                      size: "40px",
                      "aria-label": "Loading video"
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_2),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.error), 1),
                    (_ctx.canRetry)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          flat: "",
                          "no-caps": "",
                          color: "primary",
                          icon: "refresh",
                          label: "Reload",
                          loading: _ctx.loading,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadPlayback(true)))
                        }, null, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onHide"]))
}